import { render, staticRenderFns } from "./AgentPlaza.vue?vue&type=template&id=170f2b33&scoped=true"
import script from "./AgentPlaza.vue?vue&type=script&lang=js"
export * from "./AgentPlaza.vue?vue&type=script&lang=js"
import style0 from "./AgentPlaza.vue?vue&type=style&index=0&id=170f2b33&prod&lang=scss&scoped=true"
import style1 from "./AgentPlaza.vue?vue&type=style&index=1&id=170f2b33&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "170f2b33",
  null
  
)

export default component.exports